import { cn } from 'src/shared/utils/cn'

interface StepProgressBarProps {
  totalSteps: number
  /** 1-indexed current step. (First step is 1 not 0) */
  currentStep: number
  className?: string
  stepClassName?: string
  completedStepClassName?: string
  incompleteStepClassName?: string
  currentStepClassName?: string
}

export default function StepProgressBar({
  totalSteps,
  currentStep,
  className,
  stepClassName,
  completedStepClassName,
  incompleteStepClassName,
  currentStepClassName,
}: StepProgressBarProps) {
  // Ensure currentStep is within valid bounds
  const normalizedCurrentStep = Math.max(0, Math.min(currentStep, totalSteps))

  return (
    <div className={cn('flex gap-2', className)}>
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1
        const isCompleted = stepNumber <= normalizedCurrentStep
        const isCurrent = stepNumber === normalizedCurrentStep

        return (
          <div
            key={stepNumber}
            className={cn(
              'h-2 flex-1 rounded-full transition-all duration-500 ease-in-out',
              isCompleted ? cn('bg-primary', completedStepClassName) : cn('bg-[#D8D8D6]', incompleteStepClassName),
              isCurrent && currentStepClassName,
              stepClassName,
            )}
          />
        )
      })}
    </div>
  )
}
